import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";

const AuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=anon, object=auth
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await adminApi.get("/admin/me");
        if (!cancelled) setAdmin(data);
      } catch {
        if (!cancelled) setAdmin(false);
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const login = async (username, password) => {
    const { data } = await adminApi.post("/admin/login", { username, password });
    setAdmin({ username: data.username });
    return data;
  };

  const logout = async () => {
    try {
      await adminApi.post("/admin/logout");
    } catch (err) {
      // Server-side logout failed (e.g. network). Cookie may still be set;
      // we still clear local state so the UI returns to anonymous.
      console.warn("Admin logout request failed:", err?.message || err);
    }
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AuthContext);
